import { createFileRoute } from '@tanstack/react-router';

import { DocumentsPage } from '@/features/emr/pages/DocumentsPage';

export const Route = createFileRoute('/_authenticated/documents/')({
  component: DocumentsPage,
  beforeLoad: () => ({
    breadcrumbs: [{ title: 'Inbox', href: '/documents' }],
  }),
});
